import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'

Vue.component(FeatherIcon.name, FeatherIcon)

// Play system — auto-register the whole component library (src/components/play/*.vue)
// globally, so the rebrand can drop <play-*> anywhere and replace bootstrap-vue
// screen by screen. Each component is keyed by its own `name` (PlayButton, …).
const playContext = require.context('./components/play', false, /Play[A-Z]\w*\.vue$/)
playContext.keys().forEach(key => {
  const component = playContext(key).default
  if (component && component.name) {
    Vue.component(component.name, component)
  }
})
